import { getLocalFileUrl } from '../helpers/api/files.js';

const formatAssetUrl = ({ path = "", fallback = "" }) => {
    if(!path) {
        return fallback;
    }
    if(path === "/pages/placeholder.jpg") {
        return `${process.env.PUBLIC_URL}${path}`;
    }
    return getLocalFileUrl({ path });
};

export default formatAssetUrl;
